import { render, staticRenderFns } from "./DigitalPromoTransactions.vue?vue&type=template&id=c7fad5fa&"
import script from "./DigitalPromoTransactions.vue?vue&type=script&lang=js&"
export * from "./DigitalPromoTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7fad5fa')) {
      api.createRecord('c7fad5fa', component.options)
    } else {
      api.reload('c7fad5fa', component.options)
    }
    module.hot.accept("./DigitalPromoTransactions.vue?vue&type=template&id=c7fad5fa&", function () {
      api.rerender('c7fad5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/digital-promo/DigitalPromoTransactions.vue"
export default component.exports